<template>
    <form @submit.prevent="submit()">
        <div class="help-cards">
            <div class="row">
                <draggable v-model="data"  @start="drag=true" @end="drag=false">
                    <div v-for="element in data" :key="element.id" class="col-lg-3 col-md-6 col-sm-12">
                        <a class="help-card">
                            <div class="media">
                                <div class="media-left">
                                    <i class="material-icons">{{element.icon}}</i>
                                </div>
                                <div class="media-body">
                                    <div class="media-heading">{{element.title}}</div>
                                    <p>{{element.text}}</p>
                                </div>
                            </div>
                        </a>
                    </div>        
                </draggable>
            </div>
            <div class="row">
                <div class="col-xs-12 text-center">
                    <a class="btn btn-default" href="backend/centro-ayuda">Cancelar</a>
                    <button type="submit" class="btn btn-primary">Guardar</button>
                </div>
            </div>
        </div>
    </form>    
</template>
<style lang="scss" scoped>
    .wrapper-drag {
        display: flex;
    }
    .help-cards .help-card .media-left {
        color: #ed3232;
    }
    .help-cards .help-card .media-body .media-heading {
        color: #09132e;
        font-size: 18px;
        font-family: Roboto Slab,sans-serif;
        line-height: 1;
    }
    .help-cards .help-card .media-body p {
        font-size: 14px;
        color: #757575;
        font-weight: 400;
        line-height: 1.3;
    }
    .media-body, .media-left, .media-right {
        display: table-cell;
        vertical-align: top;
    }
    .media-left, .media > .pull-left {
        padding-right: 10px;
    }
    .help-cards .help-card {
        height: 170px;
        padding: 20px 15px;
        display: inline-block;
        border: 1px solid #d7d6d7;
        border-radius: 4px;
        transition: .2s ease;
        margin: 0 0 20px;
    }
    a:focus, a:hover {
        color: #23527c;
        text-decoration: underline;
    }
    a:active, a:hover {
        outline: 0;
    }
    .help-cards .help-card:hover {
        box-shadow: 0 0 10px 0 rgba(0,0,0,.3);
        text-decoration: none;
    }
</style>
<script>
import draggable from 'vuedraggable';

//transform object to array for draggable manipulation
function valuesToArray(obj) {
    return Object.keys(obj).map(function (key) { return obj[key]; });
}

export default {
    data: function(){
        
        const arr = valuesToArray(this.help_card);
        return {
            data: _.cloneDeep(arr),
            errors: {}
        }
    },
    props: ['help_card'],
    components: {
        draggable,
    },
    methods: {
        submit: function() {
            var self = this;

            axios({
                url: 'backend/centro-ayuda/order',
                method: 'POST',
                data: self.data,
            }).then(function(response){
                window.location.replace(response.data.redirect);
            }).catch(function(error){
                self.errors = error.response.data.errors;
            });
        }        
    },
}
</script>